module.exports = __webpack_public_path__ + "img/button_qiehuan_3d_01.d8eb654d.png";